import uuid from "uuid/v4";
import {ANNOTATABLE_TYPES} from "../config";

export function createAnnotation(viewer, dimensions) {
  const id = uuid();
  const { x, y, w, h, ratio } = dimensions;
  const { canvas } = viewer;
  return {
    id: `anno_${id}`,
    type: "annotation",
    motivation: "oa:commenting",
    x: x,
    y: y,
    width: w,
    height: h,
    ratio: ratio,
    target: {
      id: `${canvas.id}#xywh=${x},${y},${w},${h}`,
      type: "Image",
      format: "image/jpeg"
    },
    body: [
      {
        id: `anno_${id}/body/0`,
        type: "DataSet",
        value: {},
        format: "application/json"
      },
      {
        id: `annot_${id}/body/1`,
        type: "TextualBody",
        value: "",
        format: "text/html",
        language: "en"
      }
    ]
  };
}

export const getBoxStyles = annotation => {
  if (annotation.body && annotation.body.length > 0) {
    return {
      fontSize: `${annotation.body[0].value.fontSize}px`,
      letterSpacing: `${annotation.body[0].value.letterSpacing}px`
    };
  } else {
    return {
      //defaults
    };
  }
};

export function isAnnotatable(obj) {
  return ANNOTATABLE_TYPES.indexOf(obj.TYPE[0]) !== -1;
}
